var map = {
	"./black/piliangshanchu.png": "N3ko",
	"./blue/piliangshanchu.png": "SYop",
	"./white/piliangshanchu.png": "8zD4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Uuzq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/piliangshanchu\.png$
// module id = Uuzq
// module chunks = 24